let flightElements = document.querySelectorAll(
	'.block-program-flights__flight-data'
);

let showMoreButton = document.querySelector(
	'.block-program-flights__flights .show-more'
);

let showLessButton = document.querySelector(
	'.block-program-flights__flights .show-less'
);

const toggleShowMore = (e) => {
	e.preventDefault();
	e.currentTarget.classList.add('hide');
	showLessButton.classList.remove('hide');

	const hiddenFlightElements = document.querySelectorAll(
		'.block-program-flights__flight.hide'
	);

	hiddenFlightElements.forEach((hiddenFlightElement) => {
		hiddenFlightElement.classList.remove('hide');
	});
};

const toggleShowLess = (e) => {
	e.preventDefault();
	e.currentTarget.classList.add('hide');
	showMoreButton.classList.remove('hide');

	const hiddeableFlightElements = document.querySelectorAll(
		'.block-program-flights__flight.hideable'
	);

	hiddeableFlightElements.forEach((hiddeableFlightElement) => {
		hiddeableFlightElement.classList.add('hide');
	});
};

const initProgramFlights = () => {
	let counter = 0;

	flightElements = document.querySelectorAll(
		'.block-program-flights__flight-data'
	);

	flightElements.forEach((flightElement) => {
		if (flightElement.childNodes.length > 0) {
			counter++;
			flightElement.parentElement.classList.add('active');
			if (counter > 4) {
				flightElement.parentElement.classList.add('hide');
				flightElement.parentElement.classList.add('hideable');
			}
		} else {
			flightElement.parentElement.classList.remove('active');
		}
	});

	showMoreButton = document.querySelector(
		'.block-program-flights__flights .show-more'
	);

	showLessButton = document.querySelector(
		'.block-program-flights__flights .show-less'
	);

	showMoreButton.addEventListener('click', toggleShowMore);
	showLessButton.addEventListener('click', toggleShowLess);
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		if (flightElements.length) {
			initProgramFlights();
			window.addEventListener('aifsapi-data-changed', initProgramFlights);
		}
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
